import React, { useState } from "react";
import { connect } from "react-redux";

import Layout from "components/Layout";
import Loading from "components/Loading";
import Modal from "components/Modal";
import Header from "components/AttendanceSupervisor/Header";
import Table from "components/AttendanceSupervisor/Table";
import EmployeeDayTable from "components/AttendanceSupervisor/EmployeeDayTable";
import { AttendanceProvider } from "hooks/attendance/AttendanceContext";
import { hideModal, showModal } from "actions/modalActions";

// Constantes para los tipos de vista (deben coincidir con las utilizadas en Header.js y Table.js)
export const TIME_LIST_VIEWS = {
	list: 1,
	employee_day: 2,
	employee_week: 3,
};

/**
 * Página principal de Attendance Supervisor
 * Implementa el nuevo enfoque de separación de responsabilidades
 * La mayoría de la lógica se ha movido a hooks especializados
 */
function AttendanceSupervisor(props) {
	// Estado local para la vista (lista o tarjetas)
	const [timeListView, setTimeListView] = useState(TIME_LIST_VIEWS.list);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	// Handler para cambiar el tipo de vista
	const handleViewChange = (view) => {
		setTimeListView(view);
	};

	return (
		<>
			<AttendanceProvider
				timeListView={timeListView}
				timeRegistrationBalanceCalculation={
					props.user?.time_registration_balance_calculation
				}
			>
				<Layout
					className="page-times attendance-supervisor"
					context="times"
				>
					<Header onViewChange={handleViewChange} timeListView={timeListView} />
					{loading ? (
						<Loading />
					) : error ? (
						<div className="message-container">
							<div className="message error">
								<p>{error}</p>
							</div>
						</div>
					) : timeListView === TIME_LIST_VIEWS.employee_day ? (
						<EmployeeDayTable />
					) : (
						<Table timeListView={timeListView} />
					)}
					<Modal hideModal={props.hideModal} />
				</Layout>
			</AttendanceProvider>
		</>
	);
}

const mapStateToProps = (reducers) => {
	return {
		user: reducers.authReducer.user,
		...reducers.modalReducer,
	};
};

const mapDispatchToProps = {
	hideModal,
	showModal,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AttendanceSupervisor);
